import { Component } from '@angular/core';
import { Layout } from 'app/views/presentations/layouts/layout';
import { LayoutComponent } from 'app/views/presentations/layouts/layout.component';

@Component({
    selector: `psm-three-sections-layout-1-component`,
    templateUrl: 'threeSectionsLayout1.component.html',
    styleUrls: ['../layout.component.scss']
})

export class ThreeSectionsLayout1Component extends LayoutComponent { }

export class ThreeSectionsLayout1 extends Layout {
    public type = 'ThreeSectionsLayout1';
    public componentType = ThreeSectionsLayout1Component;
    public numberOfSections = 3;
}


// WEBPACK FOOTER //
// ./src/app/views/presentations/layouts/layouts/threeSectionsLayout1/threeSectionsLayout1.component.ts